import styled from 'styled-components';
import { Modal } from 'components/ui';
import { Col } from 'antd5';
import { StyledTable } from 'components/DataTable/DataTable.style';

export const StyledModal = styled(Modal)`
  .ant-modal-header {
    padding-bottom: 8px;
  }
  .ant-modal-body {
    padding: 0px;
  }
`;

export const TitleContainer = styled.div`
  .ant-steps {
    margin-top: 1rem;
    justify-content: center;
    width: 100%;
  }
`;

export const InspectionTypeSelector = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  padding: 0 24px 8px;
`;

export const ModalBody = styled.div`
  padding: 24px;
`;

export const LabelColumn = styled(Col)<{ paddingTop?: string }>`
  margin-right: 0.5rem;
  padding-top: ${({ paddingTop }) => paddingTop ?? '0'};
  text-align: right;

  > label {
    color: ${({ theme }) => theme.labelColor};

    span {
      color: ${({ theme }) => theme.red};
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;

  button:not(:last-of-type) {
    margin-right: 0.5rem;
  }
`;

export const ConfigurationText = styled.p`
  > p.warning-text {
    color: ${({ theme }) => theme.red};
  }
`;

export const ErrorText = styled.div`
  strong,
  p {
    color: ${({ theme }) => theme.red};
  }
`;

export const AdditionalInfoText = styled.p`
  font-size: 0.75rem;
  margin-top: 16px;
`;

export const ValidationTable = styled(StyledTable)`
  border: 1px solid ${({ theme }) => theme.borderColor};
  margin-bottom: 16px;

  .ant-pagination {
    margin-right: 16px;
  }

  td.ant-table-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
